import { UserRole } from "@/constants/users/userRole"

export const getPageButtonText = (
  userRole: string | undefined,
  defaultValue: string
) => {
  if (userRole !== UserRole.USER) {
    return defaultValue
  } else {
    return undefined
  }
}

export const getDefaultTableActionButtonText = (
  userRole: string | undefined
) => {
  if (userRole === UserRole.USER) {
    return 'View Details'
  } else {
    return 'Edit'
  }
}
